export default {
  id_id: {
    bannerImg: 'id.png',
    umText: 'Available Soon',
    requiredLogin: 'Login untuk bermain',
    jackpotId_1: {
      name: 'Jackpot Harta Karun Mistis',
      level1Jackpot: 'UTAMA',
      level2Jackpot: 'MEGA',
      level3Jackpot: 'BESAR'
    },
    jackpotId_2: {
      name: 'Jackpot Fluffy',
      level1Jackpot: 'MEGA',
      level2Jackpot: 'MAXI',
      level3Jackpot: 'MINI'
    },
    jackpotId_3: {
      name: 'Kekayaan Emas JACKPOT',
      level1Jackpot: 'GRAND',
      level2Jackpot: 'MAJOR',
      level3Jackpot: 'MINOR',
      level4Jackpot: 'MINI',
    }
  },
};
